import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

import { paths } from 'configuration/paths';
import { TranslationsKeys, useTranslate } from 'hooks/useTranslate';
import { useAuthentication } from 'hooks/useAuthentication';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import { Header } from 'components/Header';
import { Button } from 'components/ui/Button';
import { Spinner } from 'components/Spinner';
import { MessageBar } from 'components/MessageBar';
import styles from './Login.module.scss';

const Login = (): JSX.Element => {
  const navigate = useNavigate();
  const { state } = useLocation()
  const { t } = useTranslate();
  const { login, user, loggingIn } = useAuthentication();
  const { loggedIn } = user || {};
  const { online } = useOnlineStatus();
  
  useEffect(() => {
    if (loggedIn) {
      navigate(paths.mySurveys);
    }
  }, [loggedIn]);
  
  let redirectUrl: string | null = state as string;
  // do not redirect back to same page
  if (redirectUrl === paths.login) {
    redirectUrl = null;
  }

  return (
    <>
      <Header ignoreAuthError />
      <div className={styles.login}>
        <div className={styles.loginHeading}>{t(TranslationsKeys.loginPage_title)}</div>
        <div className={styles.loginDescription}>{t(TranslationsKeys.loginPage_description)}</div>
        {!online && <div className={styles.loginOfflineError}>
          <MessageBar
            variant="danger"
            showCloseAction={false}
            title={t(TranslationsKeys.loginPage_offlineErrorTitle)} 
            description={t(TranslationsKeys.loginPage_offlineErrorDescription)}
          />
        </div>}
        <Button className={styles.loginButton} onClick={() => login(redirectUrl)} state={!online ? 'disabled' : (loggingIn ? 'loading' : 'normal')}>
          {loggingIn && (
            <span className={styles.loginButtonIcon}>
              <Spinner />
            </span>
          )}
          <span>
            {loggingIn ? t(TranslationsKeys.loginPage_buttonLoadingText) : t(TranslationsKeys.loginPage_buttonText)}
          </span>
        </Button>
      </div>
    </>
  );
};

export default Login;
